export enum EStep {
    ADD_NUMBER = 'add-number',
    QR_CODE = 'qr-code',
}

export type TWhatsappAccount = {
    WhatsAppAccountId?: string;
    AddedOn?: string;
    PhoneNumber?: string;
    Session?: TWhatsappStatus;
}

export type TWhatsappStatus = {
    Message?: string,
    QrCode?: string,
    State?: string,
}

export enum EConnectionState {
    CONNECTED = 'CONNECTED',
    DISCONNECTED = 'DISCONNECTED',
    CONNECTING = 'CONNECTING',
    ERROR = 'ERROR',
}